import { types } from "../types/types";
const intitalState = {
    allBanners: [],
};

const bannerReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.BANNERS:
            return {
                ...state,
                allBanners: action.payload,
            };
        default:
            return { ...state };
    }
};

export default bannerReducer;
